<div class="block my-1 text-gray-1100">
  <div class="prose prose-sm max-w-none" [innerHTML]="rendered()"></div>
  @if (showFeedback()) {
    <div class="flex items-center gap-1 mt-1">
      <portal-feedback-thumbs
        [lsRunId]="effectiveLsRunId()"
        [clientId]="miaContext.clientId()"
        [brandId]="miaContext.brandId()" />
    </div>
  }
</div>
